import classNames from 'classnames';
import { useFormikContext } from 'formik';

const SubmitButton = (props) => {
  const { children, disabled = false, className = 'c7-btn--primary' } = props;

  const formikContext = useFormikContext();

  const { isSubmitting } = formikContext;

  return (
    <button
      type="submit"
      className={classNames(
        'c7-btn',
        className,
        isSubmitting && 'c7-btn--loading'
      )}
      disabled={isSubmitting || disabled}
      formNoValidate
    >
      {isSubmitting && <div className="c7-spinner" />}
      <span>{children}</span>
    </button>
  );
};

export default SubmitButton;
